import CustomerForm from "../../models/CustomerForm.model";
import BankAccountForm from "../../models/BankAccountForm.model";
import CommissionForm from "../../models/CommissionForm.model";
import TaxStatusForm from "../../models/TaxStatusForm.model";
import AddressForm from "../../models/AddressForm.model";
import NoteForm from "../../models/NoteForm.model";
import ReceiptModel from "@/modules/receipt/Receipt.model";
import i18n from "../../../../shared/i18n";
import CustomerService from "../../CustomerService";

import {store} from '@/plugins/vuex'
import InventoryModel from "@/modules/inventory/Inventory.model";
import ReceiptService from "@/modules/receipt/ReceiptService";
import CategoryService from "@/modules/setup/category/CategoryService";
import {Formatter} from "@/core/services/formatter.service";
import {invoiceLabels, notificationLabels} from "@/modules/invoices/invoiceActivityHelper"
import BranchService from "@/modules/setup/branch/BranchService";
import moment from "moment";
import SalesService from "@/modules/sales/SalesService";
import CustomerIdentificationFormModel from "../../models/CustomerIdentificationForm.model";
import HelperService from "@/core/services/helper.service";

const customerActivityHelper = {
  actions: {
    'create.customer': {
      message: i18n.t('Customer was created'),
      attributeLabels: new CustomerForm().attributeLabels,
    },
    'update.customer': {
      message: i18n.t('Customer was updated'),
      attributeLabels: {
        ...new CustomerForm().attributeLabels,
        interest_departments: i18n.t('Interest Categories')
      },
    },
    'create.customer_term': {
      message: i18n.t('Customer terms were created'),
      attributeLabels: new CommissionForm().attributeLabels,
    },
    'update.customer_term': {
      message: i18n.t('Customer terms were updated'),
      attributeLabels: new CommissionForm().attributeLabels,
    },
    'update.tax_status': {
      message: i18n.t('Tax status was updated'),
      attributeLabels: new TaxStatusForm().attributeLabels,
    },
    'update.payment_terms': {
      message: i18n.t('Payment terms were updated'),
      attributeLabels: new CommissionForm().attributeLabels,
    },
    'create.customer_bank_account': {
      message: i18n.t('Bank account was created'),
      attributeLabels: new BankAccountForm().attributeLabels,
    },
    'update.customer_bank_account': {
      message: i18n.t('Bank account was updated'),
      attributeLabels: new BankAccountForm().attributeLabels,
    },
    'delete.customer_bank_account': {
      message: i18n.t('Bank account was deleted'),
      attributeLabels: new BankAccountForm().attributeLabels,
    },
    'create.receipt': {
      message: (activity) => {
        return i18n.t(`Receipt {receipt_no}  was created for this customer`, {receipt_no: activity.data.receipt_no});
      },
      attributeLabels: new ReceiptModel().attributeLabels,
      urlName: 'receipt.view',
      attributeName: 'pk'
    },
    'update.receipt': {
      message: (activity) => {
        return i18n.t(`Receipt {receipt_no}  was updated for this customer`, {receipt_no: activity.data.receipt_no});
      },
      attributeLabels: new ReceiptModel().attributeLabels,
      urlName: 'receipt.view',
      attributeName: 'pk'
    },
    'update.commissions': {
      message: i18n.t('Commissions were updated'),
      attributeLabels: new CommissionForm().attributeLabels,
    },
    'update.receipt_commission': {
      message: i18n.t('Receipt commission was updated'),
    },
    'update.receipt_miscellaneous_charges': {
      message: i18n.t('Receipt miscellaneous charges were updated'),
    },
    'create.customer_note': {
      message: i18n.t('Note was created'),
      attributeLabels: new NoteForm().attributeLabels,
      excludeAttributes: ['customer']
    },
    'update.customer_note': {
      message: i18n.t('Note was updated'),
      attributeLabels: new NoteForm().attributeLabels,
      excludeAttributes: ['customer']
    },
    'delete.customer_note': {
      message: i18n.t('Note was deleted'),
      attributeLabels: new NoteForm().attributeLabels,
    },
    'create.customer_address': {
      message: (activity) => {
        const type = activity.data.type.charAt(0).toUpperCase() + activity.data.type.slice(1);
        return i18n.t(`{type} address was created`, {type});
      },
      attributeLabels: new AddressForm().attributeLabels,
      excludeAttributes: ['type', 'customer']
    },
    'update.customer_address': {
      message: (activity) => {
        const type = activity.data.type.charAt(0).toUpperCase() + activity.data.type.slice(1);
        return i18n.t(`{type} address was updated`, {type});
      },
      attributeLabels: new AddressForm().attributeLabels,
      excludeAttributes: ['type', 'customer']
    },
    'delete.customer_address': {
      message: (activity) => {
        const type = activity.data.type.charAt(0).toUpperCase() + activity.data.type.slice(1);
        return i18n.t(`{type} address was deleted`, {type});
      },
    },
    'create.customer_link': {
      excludeAttributes: ['customer'],
      message: i18n.t('Linked customer was created'),
      attributeLabels: {
        description: i18n.t('Description'),
        to_customer: i18n.t('Customer'),
      }
    },
    'update.customer_link': {
      message: i18n.t('Linked customer was updated'),
      attributeLabels: {
        to_customer: i18n.t('Customer'),
      }
    },
    'create.inventory': {
      message: i18n.t('Inventory was created'),
      attributeLabels: new InventoryModel().attributeLabels,
      excludeAttributes: ['primary_image', 'active_lot', 'dynamic_fields']
    },
    'update.inventory': {
      message: i18n.t('Inventory was updated'),
      attributeLabels: new InventoryModel().attributeLabels,
      excludeAttributes: ['primary_image', 'active_lot', 'dynamic_fields']
    },
    'create.pre_bid': {
      message: i18n.t('Pre bid was created'),
    },
    'pending': {
      message: i18n.t('Pending'),
    },
    'confirmed': {
      message: i18n.t('Confirmed'),
    },
    'rejected': {
      message: i18n.t('Rejected'),
    },
    'awaiting_deposit': {
      message: i18n.t('Awaiting Deposit'),
    },
    'update.pre_bid': {
      message: i18n.t('Pre bid was updated'),
    },
    'delete.pre_bid': {
      message: i18n.t('Pre bid was deleted'),
    },
    'update.invoice': {
      message: i18n.t('Invoice was updated'),
      attributeLabels: invoiceLabels,
    },
    'update.invoice_miscellaneous_items': {
      message: i18n.t('Invoice miscellaneous item was updated'),
    },
    'create.invoice': {
      message: i18n.t('Invoice was created'),
      excludeAttributes: ['bidder', 'currency', 'auction_house'],
      attributeLabels: invoiceLabels,
    },
    'update.bidder': {
      message: i18n.t('Bidder was updated'),
    },
    'create.bidder': {
      message: i18n.t('Bidder was created')
    },
    'delete.bidder': {
      message: i18n.t('Bidder was deleted')
    },
    'unpaid_invoice_notification': {
      message: i18n.t('Unpaid notification was sent'),
      attributeLabels: notificationLabels,
      excludeAttributes: ['action']
    },
    'overdue_invoice_notification': {
      message: i18n.t('Overdue notification was sent'),
      attributeLabels: notificationLabels,
      excludeAttributes: ['action']
    },
    'credit_note_notification': {
      message: i18n.t('Credit note notification was sent'),
      attributeLabels: notificationLabels,
      excludeAttributes: ['action']
    },
    'auction_ends_in_thirty_minutes_notification': {
      message: i18n.t('"Auction Ends In 30 Minutes" notification was sent')
    },
    'unmark_collected': {
      message: i18n.t('Invoice was unmarked collected'),
    },
    'mark_collected': {
      message: i18n.t('Invoice was marked collected'),
    },
    'cancelled.invoice': {
      message: i18n.t('Invoice was cancelled'),
    },
    'unpaid.invoice': {
      message: i18n.t('Invoice status changed to unpaid'),
    },
    'create.customer_logo': {
      message: i18n.t('Customer logo was created'),
    },
    'delete.customer_logo': {
      message: i18n.t('Customer logo was deleted'),
    },
    'update.customer_identification': {
      message: i18n.t('Customer Identification Details were updated'),
      attributeLabels: new CustomerIdentificationFormModel().attributeLabels,
    }
  },
  valueVisualizer: async (activity, attr, val) => {
    let returnValue = val;
    if (activity.name === 'customer_term') {
      if (attr === 'commissions' && val) {
        returnValue = '';
        val.forEach(obj => {
          if (obj.amount_over === 0) {
            returnValue += `Percentage: ${Formatter.asPercentage(obj.percent)}<br>`;
          } else {
            returnValue += `Percentage: ${Formatter.asPercentage(obj.percent)} | Over: ${Formatter.asCurrency(obj.amount_over, store.state.global.currentBranch.currency.symbol)}<br>`;
          }
        });
      } else if (attr === 'payment_terms' && val) {
        returnValue = val;
      } else if (attr === 'minimum_commission' && val) {
        returnValue = Math.round(val);
      } else if (attr === 'tax_status') {
        const taxStatus = store.state.global.taxStatuses.find(status => status.uuid === val);
        returnValue = taxStatus ? taxStatus.name : '';
      } else if (attr === 'withdrawal_fee' || attr === 'lot_handling_charge' || attr === 'insurance_rate' ||
        attr === 'unsold_fee') {
        returnValue = Math.round(val);
      }
    } else if (activity.name === 'customer_link') {
      if (attr === 'to_customer') {
        let response = await CustomerService.getCustomer(val);
        returnValue = response.body.display_name;
      }
    } else if (activity.name === 'customer') {
      if (attr === 'status' || attr === 'title') {
        returnValue = val.charAt(0).toUpperCase() + val.slice(1);
      } else if (attr === 'interest_departments') {
        let namesArr = [];
        for (let uuid of val) {
          let department = store.state.setup.department.departments.rows.find(d => d.uuid === uuid);
          if (department) {
            namesArr.push(Formatter.getByMasterLanguage(department.name));
          }
        }
        returnValue = namesArr.join(', ');
      }
    } else if (activity.name === 'customer_address') {
      if (attr === 'tax_rate') {
        returnValue = Math.round(val) + '%';
      }
    } else if (activity.name === 'receipt') {
      if (attr === 'branch') {
        let branch = store.state.setup.branch.branches.rows.find(b => b.uuid === val);
        returnValue = branch ? branch.name : '';
      } else if (attr === 'customer') {
        let response = await CustomerService.getCustomer(val);
        returnValue = response.body.display_name;
      } else if (attr === 'department') {
        let department = store.state.setup.department.departments.rows.find(d => d.uuid === val);
        returnValue = department ? Formatter.getByMasterLanguage(department.name) : '';
      } else if (attr === 'recommended_by') {
        let response = await CustomerService.getCustomer(val);
        returnValue = response.body.display_name;
      } else if (attr === 'unsold_fee' || attr === 'insurance_rate' ||
        attr === 'withdrawal_fee' || attr === 'minimum_commission' ||
        attr === 'lot_handling_charge') {
        returnValue = Math.round(val);
      }
    } else if (activity.name === 'inventory') {
      if (attr === 'branch') {
        let branch = store.state.setup.branch.branches.rows.find(b => b.uuid === val);
        returnValue = branch ? branch.name : '';
      } else if (attr === 'customer') {
        let response = await CustomerService.getCustomer(val);
        returnValue = response.body.display_name;
      } else if (attr === 'receipt') {
        let response = await ReceiptService.getReceipt(val);
        returnValue = response.body.receipt_no;
      } else if (attr === 'category') {
        let response = await CategoryService.getCategory(val);
        returnValue = Formatter.getByMasterLanguage(response.body.name);
      } else if (attr === 'department') {
        let department = store.state.setup.department.departments.rows.find(d => d.uuid === val);
        returnValue = department ? Formatter.getByMasterLanguage(department.name) : '';
      } else if (attr === 'status') {
        returnValue = val.charAt(0).toUpperCase() + val.slice(1);
      } else if (attr === 'item_location') {
        const location = HelperService.searchNested(store.state.global.itemLocations, val, 'uuid', 'children')
        if (location) returnValue = location.name
      }

    } else if (activity.name === 'invoice') {
      if (attr === 'branch') {
        let response = await BranchService.getBranch(val);
        returnValue = response.body.name;
      } else if (attr === 'customer') {
        let response = await CustomerService.getCustomer(val);
        returnValue = response.body.display_name;
      } else if (attr === 'auction') {
        let response = await SalesService.getSale(val);
        returnValue = response.body.sale_no;
      }
    } else if (activity.name === 'mailing') {
      if (attr === 'data') {
        returnValue = {}
        returnValue[i18n.t("Invoice")] = val.invoice_no;
        returnValue[i18n.t("Customer")] = val.customer_display_name;
        returnValue[i18n.t("Customer email")] = val.to_email;
        returnValue[i18n.t("Invoice type")] = val.invoice_type;
        returnValue[i18n.t("Success")] = val.success ? i18n.t("Yes") : i18n.t("No");
        returnValue[i18n.t("Sent at")] = moment(val.sent_at).format('DD-MM-YYYY');
      }
    }
    return returnValue;
  }
}

export default customerActivityHelper;
